var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('p',[_vm._v(" Created pastes: "+_vm._s(_vm.stats.created_pastes)),_c('br'),_vm._v(" Created pastes (Logged in): "+_vm._s(_vm.stats.logged_in_pastes)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }